import { pathOr } from 'ramda'

// Tasks
export const selectTasks = state => pathOr([], ['taskManagement', 'tasks'], state)
export const selectTasksLoading = state => pathOr(false, ['taskManagement', 'tasksLoading'], state)
export const selectTasksTotalPages = state => pathOr(1, ['taskManagement', 'tasksTotalPages'], state)
export const selectTasksCurrentPage = state => pathOr(1, ['taskManagement', 'tasksCurrentPage'], state)
export const selectTasksTotal = state => pathOr(0, ['taskManagement', 'tasksTotal'], state)

export const selectTaskStats = state => pathOr(null, ['taskManagement', 'taskStats'], state)
export const selectWindowCounts = state => pathOr(null, ['taskManagement', 'windowCounts'], state)
export const selectTaskViewCounts = state => pathOr(null, ['taskManagement', 'viewCounts'], state)
export const selectTaskStatsLoading = state => pathOr(false, ['taskManagement', 'taskStatsLoading'], state)

export const selectCreateTaskLoading = state => pathOr(false, ['taskManagement', 'createTaskLoading'], state)

export const selectCurrentTask = state => pathOr(null, ['taskManagement', 'currentTask'], state)
export const selectCurrentTaskLoading = state => pathOr(false, ['taskManagement', 'currentTaskLoading'], state)
export const selectCurrentTaskNotFound = state => pathOr(false, ['taskManagement', 'currentTaskNotFound'], state)

// Projects
export const selectProjects = state => pathOr([], ['taskManagement', 'projects'], state)
export const selectProjectsLoading = state => pathOr(false, ['taskManagement', 'projectsLoading'], state)

// Form Templates
export const selectFormTemplates = state => pathOr([], ['taskManagement', 'formTemplates'], state)
export const selectFormTemplatesLoading = state => pathOr(false, ['taskManagement', 'formTemplatesLoading'], state)
export const selectCurrentFormTemplate = state => pathOr(null, ['taskManagement', 'currentFormTemplate'], state)
export const selectCurrentFormTemplateLoading = state => pathOr(false, ['taskManagement', 'currentFormTemplateLoading'], state)
export const selectFormTemplateSaving = state => pathOr(false, ['taskManagement', 'formTemplateSaving'], state)
export const selectFormResponseSaving = state => pathOr(false, ['taskManagement', 'formResponseSaving'], state)
export const selectApproverFormSaving = state => pathOr(false, ['taskManagement', 'approverFormSaving'], state)
export const selectFormVersions = state => pathOr([], ['taskManagement', 'formVersions'], state)
export const selectFormVersionsLoading = state => pathOr(false, ['taskManagement', 'formVersionsLoading'], state)
export const selectConflicts = state => pathOr([], ['taskManagement', 'conflicts'], state)
export const selectConflictsLoading = state => pathOr(false, ['taskManagement', 'conflictsLoading'], state)
export const selectTaskActionLoading = state => pathOr(false, ['taskManagement', 'taskActionLoading'], state)

// Teams
export const selectTeams = state => pathOr([], ['taskManagement', 'teams'], state)
export const selectTeamsLoading = state => pathOr(false, ['taskManagement', 'teamsLoading'], state)

// Template Assignments
export const selectTemplateAssignments = state => pathOr([], ['taskManagement', 'templateAssignments'], state)
export const selectTemplateAssignmentsLoading = state => pathOr(false, ['taskManagement', 'templateAssignmentsLoading'], state)

// Filters
export const selectTaskFilters = state => pathOr({}, ['taskManagement', 'filters'], state)

// Selection & Bulk
export const selectSelectedTaskIds = state => pathOr([], ['taskManagement', 'selectedTaskIds'], state)
export const selectBulkActionLoading = state => pathOr(false, ['taskManagement', 'bulkActionLoading'], state)

// Task Settings
export const selectTaskSettings = state => pathOr(null, ['taskManagement', 'taskSettings'], state)
export const selectTaskSettingsLoading = state => pathOr(false, ['taskManagement', 'taskSettingsLoading'], state)

// Project Dashboard
export const selectProjectDashboard = state => pathOr(null, ['taskManagement', 'projectDashboard'], state)
export const selectProjectDashboardLoading = state => pathOr(false, ['taskManagement', 'projectDashboardLoading'], state)

export const selectActiveFilterCount = state => {
  const filters = selectTaskFilters(state)
  let count = 0
  if (filters.status && filters.status !== 'all') count++
  if (filters.type) count++
  if (filters.origin) count++
  if (filters.assignedTo) count++
  if (filters.approverId) count++
  if (filters.buildingId) count++
  if (filters.projectId) count++
  if (filters.priority) count++
  if (filters.formTemplateId) count++
  if (filters.teamId) count++
  if (filters.taskDomainId) count++
  if (filters.deadlineFrom || filters.deadlineTo) count++
  if (filters.createdFrom || filters.createdTo) count++
  return count
}
